import { useMemo } from 'react'
import cn from 'classnames'
import { useSelector } from 'react-redux'
import { getMobilePaySetting } from '../../selectors/revenueCenter'
import { MOBILE_PAY_SCAN_QR } from '../../VNTenders/Utils'
import classes from './VNOpenPriceNotice.module.scss'
import { APPLICATION_STRINGS } from '../../strings'

const VNOpenPriceNotice = ({ separator }) => {
  const mobilePaySetting = useSelector(getMobilePaySetting)
  const isRichCheckoutMenu = useMemo(() => mobilePaySetting !== MOBILE_PAY_SCAN_QR, [mobilePaySetting])

  // Menu has Rich Checkout enabled
  if (isRichCheckoutMenu) {
    return (
      <div className={cn(classes.container, classes.separator)}>
        <span className={classes.icon} />
        <span className={classes.text}>{APPLICATION_STRINGS.OPEN_PRICE_RICH_CHECKOUT_ALERT}</span>
      </div>
    )
  }

  return null
}

export default VNOpenPriceNotice
